/* eslint-disable indent */
import api from './axios';

const getUrlToUpload = async (fileName) => {
    try {
        const { data } = await api.post('file', { filename: fileName });
        return data;
    } catch (error) {
        if (!error.response) {
            throw error;
        }
        throw error.response.data ? error.response.data : error.response;
    }
};

const uploadFile = async (signedUrl, file, type = 'text/csv') => {
    try {
        const blob = new Blob([file], { type });
        const headers = {
            'Content-Type': type,
        };

        const response = await fetch(signedUrl, {
            method: 'PUT',
            body: blob,
            headers,
        });

        if (!response.ok) {
            throw new Error(`Upload failed: ${response.status} ${response.statusText}`);
        }

        return response;
    } catch (error) {
        throw error;
    }
};

export default {
    getUrlToUpload,
    uploadFile,
};
